import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const procApi = {
  // PR
  listPRs: (params) => api.get('/purchase-requests', { params }).then(unwrap),
  myPRs: () => api.get('/purchase-requests/me').then(unwrap),
  getPR: (id) => api.get(`/purchase-requests/${id}`).then(unwrap),
  createPR: (payload) => api.post('/purchase-requests', payload).then(unwrap),
  cancelPR: (id) => api.post(`/purchase-requests/${id}/cancel`).then(unwrap),

  // RFQ
  listRFQs: (params) => api.get('/rfqs', { params }).then(unwrap),
  getRFQ: (id) => api.get(`/rfqs/${id}`).then(unwrap),
  rfqComparison: (id) => api.get(`/rfqs/${id}/comparison`).then(unwrap),
  createRFQ: (payload) => api.post('/rfqs', payload).then(unwrap),
  sendRfqInvitations: (id) => api.post(`/rfqs/${id}/send-invitations`).then(unwrap),
  submitRfqResponse: (rfqVendorId, payload) => api.post(`/rfqs/responses/${rfqVendorId}`, payload).then(unwrap),

  // PO
  listPOs: (params) => api.get('/purchase-orders', { params }).then(unwrap),
  getPO: (id) => api.get(`/purchase-orders/${id}`).then(unwrap),
  createPO: (payload) => api.post('/purchase-orders', payload).then(unwrap),
  cancelPO: (id) => api.post(`/purchase-orders/${id}/cancel`).then(unwrap),

  // GR
  listGRs: (params) => api.get('/goods-receipts', { params }).then(unwrap),
  createGR: (payload) => api.post('/goods-receipts', payload).then(unwrap),

  // Inventory
  warehouses: () => api.get('/inventory/warehouses').then(unwrap),
  createWarehouse: (payload) => api.post('/inventory/warehouses', payload).then(unwrap),
  productCategories: () => api.get('/inventory/categories').then(unwrap),
  products: (params) => api.get('/inventory/products', { params }).then(unwrap),
  createProduct: (payload) => api.post('/inventory/products', payload).then(unwrap),
  stockLevels: (params) => api.get('/inventory/stock-levels', { params }).then(unwrap),
  lowStock: () => api.get('/inventory/low-stock').then(unwrap),
  movements: (params) => api.get('/inventory/movements', { params }).then(unwrap),
  transfer: (payload) => api.post('/inventory/transfer', payload).then(unwrap),
  adjustment: (payload) => api.post('/inventory/adjustment', payload).then(unwrap),
  valuation: (params) => api.get('/inventory/valuation', { params }).then(unwrap),

  // Suppliers
  vendorContracts: (params) => api.get('/suppliers/contracts', { params }).then(unwrap),
  createVendorContract: (payload) => api.post('/suppliers/contracts', payload).then(unwrap),
  vendorPerformance: (params) => api.get('/suppliers/performance', { params }).then(unwrap),
  saveVendorPerformance: (payload) => api.put('/suppliers/performance', payload).then(unwrap),
};
